import React from "react";
import { TestCaseResponse } from "../types";
import ResultCard from "./ResultCard";

interface ResultsDisplayProps {
  results: TestCaseResponse;
  onNewTest: () => void;
}

const ResultsDisplay: React.FC<ResultsDisplayProps> = ({
  results,
  onNewTest,
}) => {
  const categories = [
    { key: "softwareRequirements", title: "Software Requirements" },
    { key: "integrationTests", title: "Integration Tests" },
    { key: "functionalTests", title: "Functional Tests" },
    { key: "e2eTests", title: "End-to-End Tests" },
    { key: "apiTests", title: "API Tests" },
    { key: "unclearRequirements", title: "Unclear Requirements" },
  ];

  return (
    <div className="results-display">
      <div className="results-header">
        <h2>Generated Test Cases</h2>
        <button onClick={onNewTest} className="new-test-button">
          Generate New Test
        </button>
      </div>

      <div className="results-grid">
        {categories.map((category) => (
          <ResultCard
            key={category.key}
            title={category.title}
            content={results[category.key as keyof TestCaseResponse]}
          />
        ))}
      </div>
    </div>
  );
};

export default ResultsDisplay;
